import React from "react";

function PageNotFound() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex:",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "white",
        color: "Black",
      }}
    >
      PageNotFound
    </div>
  );
}

export default PageNotFound;
